import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const getSourceConversionReport = async (period) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dashboard/api/lead-report/source_conversion_report/?period=${period}`,
      getHeaders()
    );
    return response.data; // Return the entire response (data and list)
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch source conversion report"
    );
  }
};
